module.exports = __webpack_public_path__ + "img/ic_down.9896806f.svg";